import React, { Component } from 'react';
import { ButtonGroup } from 'reactstrap';
import SideBarBtn from './SideBarBtn.js';
import BtnProgram from '../images/btnProgram.jpg';
import BtnProgramActive from '../images/btnProgramActive.jpg';
import BtnProject from '../images/btnProject.jpg';
import BtnProjectActive from '../images/btnProjectActive.jpg';
import BtnSupport from '../images/btnSupport.jpg';
import BtnSupportActive from '../images/btnSupportActive.jpg';

// function addCSS(fileName) {

//   var head = document.head;
//   var link = document.createElement("link");

//   link.type = "text/css";
//   link.rel = "stylesheet";
//   link.href = fileName;

//   head.appendChild(link);

	// var themeButton = document.getElementById('styleSwap');
	// styleSwap.classList.add(.)
//   this.setState({
//     createModalSubsection: nextModalSubsection
//   });
// }

// let stylesheet = '/theme.css';
// addCss('/theme.css');

class SideBar extends Component {
	render() {
		return (
			<div className="sidebar2">
				<ButtonGroup vertical>
					<SideBarBtn
						imgsection="Project"
						section={this.props.section}
						changeSection={this.props.changeSection}
						targetSection="PROJECT"
						imgsrc={this.props.section === 'PROJECT' ? BtnProjectActive : BtnProject}
						addClass={this.props.section === 'PROJECT' ? 'active sidebarbtn2' : 'sidebarbtn2'}
					/>{' '}
					<SideBarBtn
						imgsection="Program"
						section={this.props.section}
						changeSection={this.props.changeSection}
						targetSection="PROGRAM"
						imgsrc={this.props.section === 'PROGRAM' ? BtnProgramActive : BtnProgram}
						addClass={this.props.section === 'PROGRAM' ? 'active sidebarbtn2' : 'sidebarbtn2'}
					/>{' '}
					<SideBarBtn
						imgsection="Hardware"
						section={this.props.section}
						changeSection={this.props.changeSection}
						targetSection="HARDWARE"
						imgsrc={this.props.section === 'HARDWARE' ? BtnSupportActive : BtnSupport}
						addClass={this.props.section === 'HARDWARE' ? 'active sidebarbtn2' : 'sidebarbtn2'}
					/>
				</ButtonGroup>
				<div 
					className={this.props.themeName === 'DARK' ? 'lightDarkMode light' : 'lightDarkMode dark'}
					id="styleSwap" 
					onClick={() => this.props.themeSwap()}
				>
					<span>{this.props.themeName === 'DARK' ? 'LIGHT THEME' : 'DARK THEME'}</span>
				</div>
			</div>
		);
	}
}

export default SideBar;



// WEBPACK FOOTER //
// ./src/components/SideBar.js